import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { getProjectDetails } from '../../service';
import { getPrimaryStepperSteps } from '../utils';

export function useAnalystProjectView(projectId) {
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(false);

  const primarySteps = useMemo(
    () => getPrimaryStepperSteps(projectData?.commonDetails),
    [projectData?.commonDetails],
  );

  const fetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getProjectDetails(projectId);
      setProjectData(data);
    } catch (error) {
      toast.error(
        logError({
          message: 'Failed to fetch project details',
          error: error,
          code: 'ANALYST_PROJECT_VIEW_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (projectId) {
      fetchProjectData();
    }
  }, [fetchProjectData, projectId]);

  return { projectData, loading, primarySteps, refresh: fetchProjectData };
}
